import { render, staticRenderFns } from "./Revenus.vue?vue&type=template&id=c6efd1a2&"
import script from "./Revenus.vue?vue&type=script&lang=js&"
export * from "./Revenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports